// components/TeamRelatedNews.tsx
import React from 'react';
import { useQuery, gql } from '@apollo/client';
import FeaturedNewsPost from './featured-news-post';
import { IPost } from '../models/post';
import { H4, H3 } from './text';
import { CgSpinnerAlt } from 'react-icons/cg';

const GET_TEAM_RELATED_NEWS = gql`
	query TeamRelatedNews($tagSlug: String!) {
		posts(first: 3, where: { tagSlugIn: [$tagSlug], categoryNotIn: [3] }) {
			edges {
				node {
					id
					title
					slug
					date
					excerpt
					featuredImage {
						node {
							sourceUrl
						}
					}
					tags(first: 1) {
						nodes {
							name
							slug
						}
					}
					author {
						node {
							name
							firstName
							lastName
							avatar {
								url
							}
						}
					}
				}
			}
		}
	}
`;

interface TeamRelatedNewsProps {
	tagSlug: string;
}

const TeamRelatedNews: React.FC<TeamRelatedNewsProps> = ({ tagSlug }) => {
	const { data, loading, error } = useQuery(GET_TEAM_RELATED_NEWS, {
		variables: { tagSlug },
		fetchPolicy: 'network-only',
	});

	if (loading) {
		return (
			<div className="flex flex-col items-center h-full fixed w-full justify-center ">
				<CgSpinnerAlt className="animate-spin text-black w-16 h-16" />
			</div>
		);
	}

	if (error) return <p>Error loading news: {error.message}</p>;

	const newsPosts: IPost[] = data?.posts?.edges || [];

	if (newsPosts.length === 0) {
		return (
			<div className="text-center p-8 bg-gray-100 rounded">
				<p>Geen recente nieuwsberichten gevonden</p>
			</div>
		);
	}

	return (
		<div className="mb-12">
			<H3 className="mb-4 lg:mb-6 !text-3xl !lg:text-4xl ">Laatste nieuws</H3>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
				{newsPosts.map((postEdge: any) => {
					const post = postEdge.node;
					return (
						<FeaturedNewsPost
							key={post.id}
							title={post.title}
							coverImage={post.featuredImage}
							slug={post.slug}
							excerpt={post.excerpt}
							date={post.date}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default TeamRelatedNews;
